import type { CSSProperties, HTMLAttributes } from "react";
import clsx from "clsx";

import "./dotm-square-11.scss";

const GRID_SIZE = 5;

export interface DotmSquare11Props
  extends HTMLAttributes<HTMLDivElement> {
  size?: number;
  dotSize?: number;
  speed?: number;
  bloom?: boolean;
}

export const DotmSquare11 = ({
  size = 32,
  dotSize = 4,
  speed = 1.2,
  bloom = false,
  className,
  style,
  ...props
}: DotmSquare11Props) => {
  const gap = Math.max(1, Math.round(dotSize * 0.6));
  const center = (GRID_SIZE - 1) / 2;
  const dots = Array.from({ length: GRID_SIZE * GRID_SIZE }, (_, index) => {
    const row = Math.floor(index / GRID_SIZE);
    const column = index % GRID_SIZE;
    const ringDistance = Math.max(
      Math.abs(row - center),
      Math.abs(column - center),
    );

    return {
      key: `${row}-${column}`,
      delay: ringDistance * 0.12,
      row,
      column,
    };
  });

  const mergedStyle = {
    width: size,
    height: size,
    ["--dot-size" as any]: `${dotSize}px`,
    ["--dot-gap" as any]: `${gap}px`,
    ["--dot-speed" as any]: `${speed}s`,
    ...style,
  } as CSSProperties;

  return (
    <div
      {...props}
      className={clsx("DotmSquare11", bloom && "DotmSquare11--bloom", className)}
      style={mergedStyle}
    >
      {dots.map((dot) => (
        <span
          key={dot.key}
          className="DotmSquare11__dot"
          style={{
            ["--dot-delay" as any]: `${dot.delay}s`,
            gridRowStart: dot.row + 1,
            gridColumnStart: dot.column + 1,
          }}
        />
      ))}
    </div>
  );
};
